
export type ScriptTypes = "IronRuby" | "DynamicExpresso" | "JavaScript" | "Constant" | "Regex" | "Special" | null;

export interface ServerDynamicFormResponse {
	formTypeName: string;
	projectSuffix: string;

	jsonDescriptor: DynamicFormPartType;

	isSimpleFormat: boolean;

	scanModuleWorkUrl: string;
	scanModuleInstallUrl: string;
	scanModuleVersion: string;
};

export enum ControlKeyType {
	InPlaceCollapsedView = "InPlaceCollapsedView",
	MultiStringText = "MultiStringText",
	SimpleText = "SimpleText",
	DatePicker = "DatePicker",
	OnlyCaption ="OnlyCaption",
	ComboBox = "ComboBox",
	CheckBoxText = "CheckBoxText",
	Label = "Label",
	FiasRegionSelectControlViewModel = "FiasRegionSelectControlViewModel",
	CheckComboBox = "CheckComboBox"
};

export enum DescriptorKeyType {
	Placeholder = "Placeholder",
	FormDescriptor = "FormDescriptor",
	TextControlDescriptor = "TextControlDescriptor",
	EnumControlDescriptor = "EnumControlDescriptor",
	BoolControlDescriptor = "BoolControlDescriptor",
	DateControlDescriptor = "DateControlDescriptor",
	IntegerControlDescriptor = "IntegerControlDescriptor",
	FloatControlDescriptor = "FloatControlDescriptor",
	UuidControlDescriptor = "UuidControlDescriptor",
	DictionaryRegistryControlDescriptor = "DictionaryRegistryControlDescriptor",
	SimpleAttachmentViewModel = "SimpleAttachmentViewModel",
	CurrentUserViewModel = "CurrentUserViewModel",
	TitleControlDescriptor = "TitleControlDescriptor",
	PageDescriptor = "PageDescriptor",
	PageContainerControlDescriptor = "PageContainerControlDescriptor",
	FiasRegionSelectControlViewModel = "FiasRegionSelectControlViewModel",
	FIAS = "FIAS",
	UserInfoList = "UserInfoList",
	CustomerSelect = "CustomerSelect",
	CollectionFormDescriptor = "CollectionFormDescriptor"
};

export type EnumLiteralType = {
	DA: string;
	LV: string;
	UV: number;
};

export type ScriptDescriptionType = {
	ScriptType: ScriptTypes;
	Content: string;
	Message?: string;
	LaunchCondition?: ScriptDescriptionType;
};

export type DynamicFormPartType = {
	
	ControlKey: ControlKeyType;
	DescriptorKey: DescriptorKeyType;
	LocalPath: string;
	Path: string;
	ParentPath: string | null;
	viewModelPath: string;

	IsClientScripts: boolean;
	IsMandatory: boolean;

	Tooltip?: string;
	CopyButton: boolean;
	Caption: string;
	NullTitle?: string;
	Mask?: string;
	Pinput?: string;
	MinLength: number;
	MaxLength: number;
	MaxValue: string | number;
	MinValue: string | number;
	Width?: number;
	IsSave?: boolean;

	DefaultValueScript?: ScriptDescriptionType;
	DisplayScript?: ScriptDescriptionType;
	MandatoryScript?: ScriptDescriptionType;
	CalculationScript?: ScriptDescriptionType;
	EnabledScript?: ScriptDescriptionType;
	ValidationScripts?: Array<ScriptDescriptionType>;
	MaxItemsCountScript?: ScriptDescriptionType;
	MinDateScript?: ScriptDescriptionType;
	MaxDateScript?: ScriptDescriptionType;

	FormElements?: Array<DynamicFormPartType>;
	EnumLiterals?: Array<EnumLiteralType>;

	Pages?: Array<DynamicFormPartType>;
	ButtonCaption?: string;
	CollectionItems?: Array<DynamicFormPartType>;
	PageElements?: Array<DynamicFormPartType>;

	CollectionElementDescriptor?: DynamicFormPartType;

	DictionaryId?: string;
	DictionarySource?: string;
	ParentId?: string;
	ExternalRequest?: string;
	DisplayFieldScript?: ScriptDescriptionType;
};
